/* eslint-disable react/no-unknown-property */
import React from 'react';
import { IconsPropsType } from './icons.config.type';

const FromHigherInjection: React.FC<IconsPropsType> = ({ style, color, onClick, className }) => {
  return (
    <svg
      style={{ ...style }}
      width="33"
      height="30"
      viewBox="0 0 33 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="13.5" y="0.5" width="19" height="29" rx="2.5" stroke="black" />
      <path
        d="M26.053 15.0959L16.3308 9.09595V12.4226L1.05302 12.4293L1.05302 17.7626H16.3308V21.0959L26.053 15.0959Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // </div>
  );
};

FromHigherInjection.defaultProps = {
  style: { width: '33px', height: '30px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default FromHigherInjection;
